import { render, staticRenderFns } from "./TransferFromGasSource.vue?vue&type=template&id=2b08f342&"
import script from "./TransferFromGasSource.vue?vue&type=script&lang=js&"
export * from "./TransferFromGasSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports